import type {ReactNode} from 'react';
import {clsx} from 'clsx';
import {Card} from '@goproblems/ui';

export const DashboardTabbedCard = ({
    title,
    titleBadge,
    summary,
    description,
    className,
    tabs,
    action,
    children,
}: {
    title: string;
    titleBadge?: ReactNode;
    summary?: ReactNode;
    description?: ReactNode;
    className?: string;
    tabs?: ReactNode;
    action?: ReactNode;
    children: ReactNode;
}) => (
    <Card className={clsx('dashboard-tabbed-card', className)}>
        <header
            className={clsx('dashboard-tabbed-card-header', {
                'is-compact':
                    !titleBadge &&
                    !summary &&
                    !description &&
                    !tabs &&
                    !action,
            })}>
            {titleBadge || summary || description ? (
                <div className="dashboard-tabbed-card-title">
                    <h1>{title}</h1>
                    {titleBadge}
                    {summary && (
                        <div className="dashboard-tabbed-card-summary">
                            {summary}
                        </div>
                    )}
                    {description && (
                        <p className="dashboard-tabbed-card-description">
                            {description}
                        </p>
                    )}
                </div>
            ) : (
                <h1>{title}</h1>
            )}
            {tabs}
            {action && (
                <div className="dashboard-tabbed-card-action">{action}</div>
            )}
        </header>
        {children}
    </Card>
);
